import { createEntityAdapter } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { ContentTagSummaryModel } from 'types/entity';

export const contentTagAdapter = createEntityAdapter<ContentTagSummaryModel>({
  selectId: (model) => model.content_tag_id,
});

export const {
  // selectById: selectLayoutById,
  // selectIds: selectLayoutIds,
  // selectEntities: selectLayoutEntities,
  selectAll: selectAllContentTags,
  // selectTotal: selectTotalLayouts,
} = contentTagAdapter.getSelectors<RootState>((state) => state.contentTagRead);
